module.exports = __webpack_public_path__ + "img/INTERIOR-SCROSS-3.02075852.jpg";